import React, { useLayoutEffect, useMemo, useState } from 'react';
import SearchButton from './SearchButton';
import SpeciesButton from './SpeciesButton';

interface ISpeciesButtonBarProps {
  groups: Array<any>
  isMobile: boolean;
  onSelected: any;
  onReady?: () => void;
  onOpenMenu?: () => void;
}
export default function SpeciesButtonBar(props: ISpeciesButtonBarProps) {
  const { groups, isMobile, onOpenMenu, onReady, onSelected } = props;
  const [openName, setOpenName] = useState<string | null>(null);
  const searchPanelName = '__search__';

  useLayoutEffect(() => {
    onReady?.();
  }, [onReady]);

  const speciesButtons = useMemo(
    () => {
      return groups
        .filter((current) => (current.entries?.length ?? 0) > 0)
        .map((current) => (
        <SpeciesButton
          key={`species-button-${current.key}`}
          img={current.image}
          group={current}
          isMobile={isMobile}
          onSelected={onSelected}
          closeOnSelection={isMobile}
          isOpen={openName === current.name}
          onOpen={() => {
            onOpenMenu?.();
            setOpenName(current.name);
          }}
          onClose={() => {
            setOpenName((currentName) => currentName === current.name ? null : currentName);
          }} />
      ));
    },
    [groups, isMobile, onOpenMenu, onSelected, openName]
  );

  return (
    <div className="button-container">
      <div className="button-cluster">
        <SearchButton
          groups={groups}
          isMobile={isMobile}
          isOpen={openName === searchPanelName}
          onOpen={() => {
            onOpenMenu?.();
            setOpenName(searchPanelName);
          }}
          onClose={() => {
            setOpenName((currentName) => currentName === searchPanelName ? null : currentName);
          }}
          onSelected={onSelected}
        />
        <div className="button-row">
          {speciesButtons}
        </div>
      </div>
    </div>
  );
}